import type {
    ChatBotButtonBaseSettingsFormGroupType,
    ChatBotButtonHoverSettingsFormGroupType,
    ChatBotElementFormGroup,
    ChatBotWidgetDataFormGroup,
} from '../type/chat-bot-widget.type';

import { FormArray, FormControl, FormGroup } from '@angular/forms';

export const chatBotButtonBaseSettingsForm = (): ChatBotButtonBaseSettingsFormGroupType =>
    new FormGroup({
        color: new FormControl(null),
        background: new FormControl(null),
        borderColor: new FormControl(null),
        borderWidth: new FormControl(null),
        borderRadius: new FormControl(null),
        borderStyle: new FormControl(null),
    });

export const chatBotButtonHoverSettingsForm = (): ChatBotButtonHoverSettingsFormGroupType =>
    new FormGroup({
        hoverType: new FormControl(null),
        opacity: new FormControl(null),
        shadow: new FormControl(null),
        color: new FormControl(null),
        background: new FormControl(null),
        borderColor: new FormControl(null),
    });

export const chatBotWidgetDataFormGroup = (): ChatBotWidgetDataFormGroup =>
    new FormGroup({
        chatBots: new FormArray([]),
        socialNetwork: new FormControl(null),
        type: new FormControl(null),
        iconType: new FormControl(null),
        horizontalAlign: new FormControl(null),
        mobileHorizontalAlign: new FormControl(null),
        tabletHorizontalAlign: new FormControl(null),
        height: new FormControl(null),
        buttonSize: new FormControl(null),
        isIndependentCorners: new FormControl(null),
        advancedRadius: new FormGroup({
            borderTopLeftRadius: new FormControl(null),
            borderTopRightRadius: new FormControl(null),
            borderBottomLeftRadius: new FormControl(null),
            borderBottomRightRadius: new FormControl(null),
        }),
        advancedBorderSettings: new FormControl(null),
        isSynchronizeStyle: new FormControl(null),
        hideOnMobile: new FormControl(null),
        hideOnDesktop: new FormControl(null),
        hideOnTablet: new FormControl(null),
        position: new FormGroup({
            x: new FormControl(null),
            tabletX: new FormControl(null),
            mobileX: new FormControl(null),
            y: new FormControl(null),
            tabletY: new FormControl(null),
            mobileY: new FormControl(null),
            rotate: new FormControl(null),
            tabletRotate: new FormControl(null),
            mobileRotate: new FormControl(null),
            zIndex: new FormControl(null),
            tabletZIndex: new FormControl(null),
            mobileZIndex: new FormControl(null),
            width: new FormControl(null),
            tabletWidth: new FormControl(null),
            mobileWidth: new FormControl(null),
        }),
        styleType: new FormControl(null),
        buttonBase: chatBotButtonBaseSettingsForm(),
        buttonHover: chatBotButtonHoverSettingsForm(),
        isShadow: new FormControl(null),
        shadowSettings: new FormControl(null),
    });

export const chatBotElementFormGroup = (): ChatBotElementFormGroup =>
    new FormGroup({
        socialNetwork: new FormControl(null),
        type: new FormControl(null),
        iconType: new FormControl(null),
        name: new FormControl(null),
        link: new FormControl(null),
        description: new FormControl(null),
        botName: new FormControl(null),
        botId: new FormControl(null),
        variables: new FormGroup({
            bot_id: new FormControl(null),
            _id: new FormControl(null),
            name: new FormControl(null),
            value_type: new FormControl(null),
            value: new FormControl(null),
            created_at: new FormControl(null),
            updated_at: new FormControl(null),
        }),
        botChain: new FormGroup({
            chainId: new FormControl(null),
            name: new FormControl(null),
            isDefault: new FormControl(null),
        }),
        uri: new FormControl(null),
        phone: new FormControl(null),
        preventLinkConverting: new FormControl(null),
    });
